import { buildSearchEngine } from '@coveo/headless';
import {
  PostprocessFacetSearchResponseMiddleware,
  PostprocessQuerySuggestResponseMiddleware,
  PostprocessSearchResponseMiddleware
} from '@coveo/headless/dist/definitions/api/search/search-api-client-middleware';
import { PreprocessRequest } from '@coveo/headless/dist/definitions/api/preprocess-request';
import { PlatformResponse } from '@coveo/headless/dist/definitions/api/platform-client';
import { SearchResponseSuccess } from '@coveo/headless/dist/definitions/api/search/search/search-response';
import { FacetSearchResponse } from '@coveo/headless/dist/definitions/api/search/facet-search/facet-search-response';
import { QuerySuggestSuccessResponse } from '@coveo/headless/dist/definitions/api/search/query-suggest/query-suggest-response';

export type ExtendedWindowType = Window &
  typeof globalThis & {
    preProcessRequest: CallableFunction;
    modalPreProcessRequest: CallableFunction;
    dataLayer: object[];
  };

const wrapper = document.getElementsByClassName(
  'coveo-listing__data-wrapper'
)?.[0];

const modalWrapper = document.getElementsByClassName(
  'coveo-listing__data-wrapper-modal'
)?.[0];

const searchWrapper = document.getElementsByClassName(
  'coveo-listing__data-wrapper-search'
)?.[0];

const dataset = wrapper ? (wrapper as HTMLElement).dataset : null;

const datasetModal = modalWrapper
  ? (modalWrapper as HTMLElement).dataset
  : null;

const datasetSearch = searchWrapper
  ? (searchWrapper as HTMLElement).dataset
  : null;

const coveoConfig = dataset ? JSON.parse(dataset.coveo as string) : null;

const coveoConfigModal = datasetModal
  ? JSON.parse(datasetModal.coveo as string)
  : null;

const coveoConfigSearch = datasetSearch
  ? JSON.parse(datasetSearch.coveo as string)
  : null;

const global = window as ExtendedWindowType;

const postprocessSearchResponse: PostprocessSearchResponseMiddleware = (
  response: PlatformResponse<SearchResponseSuccess>
) => {
  response.body?.results.forEach(result => result);
  return response;
};

const postprocessFacetSearchResponse: PostprocessFacetSearchResponseMiddleware =
  (response: PlatformResponse<FacetSearchResponse>) => {
    return response;
  };

const postprocessQuerySuggestSearchResponse: PostprocessQuerySuggestResponseMiddleware =
  (response: PlatformResponse<QuerySuggestSuccessResponse>) => {
    return response;
  };

const preprocessRequest: PreprocessRequest = (request, clientOrigin) => {
  if (global.preProcessRequest) {
    if (clientOrigin === 'searchApiFetch' && request.body) {
      const body = global.preProcessRequest(request.body.toString());
      request.body = body;
    }
    // E.g., modify facet requests
    // body.facets = [...];
  }

  if (clientOrigin === 'analyticsFetch') {
    // E.g., send data to a third party
  }

  // Return the modified request
  return request;
};

const modalPreprocessRequest: PreprocessRequest = (request, clientOrigin) => {
  if (global.modalPreProcessRequest) {
    if (clientOrigin === 'searchApiFetch' && request.body) {
      const body = global.modalPreProcessRequest(request.body.toString());
      request.body = body;
    }
    // E.g., modify facet requests
    // body.facets = [...];
  }

  if (clientOrigin === 'analyticsFetch') {
    // E.g., send data to a third party
  }

  // Return the modified request
  return request;
};

export const config = coveoConfig && {
  organizationId: coveoConfig.OrganizationId,
  accessToken: coveoConfig.ApiKey,
  search: {
    searchHub: coveoConfig.SearchHubPipeline,
    pipeline: coveoConfig.SearchHubPipeline,
    preprocessSearchResponseMiddleware: postprocessSearchResponse,
    preprocessFacetSearchResponseMiddleware: postprocessFacetSearchResponse,
    preprocessQuerySuggestResponseMiddleware:
      postprocessQuerySuggestSearchResponse
  },
  analytics: {
    originLevel3: document?.referrer ? document.referrer : 'none'
  },
  preprocessRequest
};

export const headlessEngine = coveoConfig
  ? buildSearchEngine({
      configuration: config
    })
  : null;

export const modalConfig = coveoConfigModal && {
  organizationId: coveoConfigModal.OrganizationId,
  accessToken: coveoConfigModal.ApiKey,
  search: {
    searchHub: coveoConfigModal.SearchHubPipeline,
    pipeline: coveoConfigModal.SearchHubPipeline,
    preprocessSearchResponseMiddleware: postprocessSearchResponse,
    preprocessFacetSearchResponseMiddleware: postprocessFacetSearchResponse,
    preprocessQuerySuggestResponseMiddleware:
      postprocessQuerySuggestSearchResponse
  },
  analytics: {
    originLevel3: document?.referrer ? document.referrer : undefined
  },
  preprocessRequest: modalPreprocessRequest
};

export const searchConfig = coveoConfigSearch && {
  organizationId: coveoConfigSearch.OrganizationId,
  accessToken: coveoConfigSearch.ApiKey,
  search: {
    searchHub: coveoConfigSearch.SearchHubPipeline,
    pipeline: coveoConfigSearch.SearchHubPipeline
  }
};

export const headlessEngineModal = modalConfig
  ? buildSearchEngine({
      configuration: modalConfig
    })
  : '';

export const headlessEngineSearch = searchConfig
  ? buildSearchEngine({
      configuration: searchConfig
    })
  : '';
